function retrieveCrewTaskVisibility(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/crew-task-visibility`);
}

function updateCrewTaskVisibility(companyId, crewTaskVisibility) {
    return window.tenantAxios.patch(`/company/${companyId}/crew-task-visibility`, crewTaskVisibility);
}

export default {
    retrieveCrewTaskVisibility,
    updateCrewTaskVisibility,
};
